/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSouscriptionPaymentRefundMutation from '../graphql/mutations/SaveSouscriptionPaymentRefundMutation.js';

export const useSaveSouscriptionPaymentRefundMutation = () => {
  return useCommitMutation(SaveSouscriptionPaymentRefundMutation, {
    dataProp: 'saveSouscriptionPaymentRefund_M_souscription_payment_refund'
  });
};

export default useSaveSouscriptionPaymentRefundMutation;
